<template>
  <BaseDialog
    :is-open="isRevealed || isShowing"
    @close="onCancel"
  >
    <div>
      <div class="text-center sm:ml-4 sm:mt-0 sm:text-left">
        <template v-if="title !== undefined">
          <HeadlessDialogTitle
            as="h3"
            class="text-lg font-medium leading-6"
          >
            {{ title }}
          </HeadlessDialogTitle>
        </template>
        <div :class="title ? 'mt-2' : ''">
          <p class="text-sm text-background-fg/87">
            {{ description }}
          </p>
        </div>
      </div>
    </div>

    <div class="mt-5 space-y-3">
      <slot name="actions">
        <BaseConfirmationButton
          variant="negative"
          @click="onConfirm"
        >
          {{ confirmLabel }}
        </BaseConfirmationButton>

        <BaseConfirmationButton
          variant="cancel"
          @click="onCancel"
        >
          {{ cancelLabel }}
        </BaseConfirmationButton>
      </slot>
    </div>
  </BaseDialog>
</template>

<script setup lang="ts">
import { useConfirmDialog } from "@vueuse/core"

const props = withDefaults(
  defineProps<{
    title?: string
    description?: string
    confirmLabel?: string
    cancelLabel?: string
    isShowing?: boolean
  }>(),
  {
    title: undefined,
    description: undefined,
    confirmLabel: "Yes",
    cancelLabel: "No",
    isShowing: false,
  }
)

const emit = defineEmits<{
  (event: "confirm"): void
  (event: "cancel"): void
}>()

const { reveal, isRevealed, confirm, cancel } =
  useConfirmDialog()

defineExpose({
  reveal,
})

const onConfirm = () => {
  confirm()
  emit("confirm")
}

const onCancel = () => {
  cancel()
  emit("cancel")
}
</script>
